import {
  Accordion,
  AccordionDetails,
  AccordionSummary,
  Box,
  CssBaseline,
  Divider,
  Grid,
  IconButton,
  Stack,
  Typography,
  useMediaQuery,
} from "@mui/material";
import InstagramIcon from "@mui/icons-material/Instagram";
import logo from "../assets/logo.png";
import logoKabita from "../assets/kabita.png";
import logoGrabfood from "../assets/Layer 1.png";
import logoGofood from "../assets/Layer 2.png";
import logoShopeefood from "../assets/Layer 3.png";
import { ExpandMore } from "@mui/icons-material";
import { useEffect, useState } from "react";
import axios from "axios";

const parseBrandsFromApi = (outlet) => {
  const brands = {};

  Object.entries(outlet).forEach(([key, value]) => {
    if (!key.startsWith("link_") || !value) return;
    
    const [, platform, brand] = key.split("_");

    if (!brands[brand]) {
      brands[brand] = {};
    }

    brands[brand][platform] = value;
  });

  return brands;
};

const formatBrand = (str) =>
  str.charAt(0).toUpperCase() + str.slice(1);

const Footer = () => {
  const mobile_size = useMediaQuery("(max-width:600px)");
  const desktop_size = useMediaQuery("(min-width:600px)");

  const [outlets, setOutlets] = useState([]);

  useEffect(() => {      
    // Get data Outlet
    axios({
      method: "get",
      url: `https://script.google.com/macros/s/AKfycbwMR-2Dk9gpd5_KlmhL1Lgk_opPU6OOzb-KJQjizlRtYpKtX_Bp7QWa4i172CDKoRbE/exec?api=outlet`,     
    })
    .then((response) => {
      const rawData = response.data;
      setOutlets(rawData.data);
    })
    .catch((err) => {});
  }, []);  

  return (
    <>
      <CssBaseline />

      {/* Mobile */}
      {mobile_size && (
        <Box
          width="100%"
          backgroundColor="ivory"
          display="flex"
          flexDirection="column"
          alignItems="center"
          justifyContent="center"
          paddingTop="1em"
        >
          {/* Detail Logo */}
          <Box
            width="100%"
            display="flex"
            flexDirection="column"
            // backgroundColor="#ae2129"
            alignItems="center"
            justifyContent="center"
            marginBottom=".5em"
            // marginBottom="1em"
            // paddingTop=".2em"
            // paddingBottom=".2em"
            // borderRadius="2em"
          >
            <img 
              src={logoKabita} 
              className="footer-logo" 
              alt="logo-kabita" 
              style={{                 
                filter: "brightness(0) saturate(100%) invert(29%) sepia(39%) saturate(2622%) hue-rotate(349deg) brightness(111%) contrast(99%)",
                width: 250,
                objectFit: "contain",                
                pointerEvents: "none",                  
                animation: "fade-in ease 3s",
                transition: "0.03s ease-in-out",
              }} 
            />
          </Box>

          {/* Title and Subtitle */}
          {/* <div className="footer-title-mobile">Seojun Fried Chicken</div>
          <div className="footer-subtitle-mobile">Your daily happiness</div> */}
          {/* <div className="footer-title-mobile">Kabita Group</div>           */}

          <Divider width="90%" height="4px" color="grey" margintop="1em" sx={{ marginY: 1 }} />          

          {/* Navigation */}
          <Box
            width="80%"
            display="flex"
            flexDirection="column"
            justifyContent="flex-start"
            alignItems="center"
            margintop="1em"
          >
            <div className="footer-title-mobile">Navigation</div>
            <a className="footer-link-mobile" href="#section-menu">
              Menu
            </a>
            {/* <a className="footer-link-mobile" href="/#">
              Location
            </a> */}
          </Box>

          <br />

          <div className="footer-title-mobile">Follow</div>
          {/* List icon */}
          <div className="footer-social-btn-list">
            <IconButton
              onClick={() => {
                window.open(
                  // "https://instagram.com/seojunfriedchicken?igshid=MzRlODBiNWFlZA=="
                  "https://www.instagram.com/eatkabita/"                  
                );
              }}              
            >
              <InstagramIcon sx={{ width: "1.5em", height: "1.5em", color: "#df4715" }} />
            </IconButton>
          </div>

          <br />
          <div className="footer-title-mobile">Available at</div>

          <Box width="90%" my={1}>
            {outlets.map((outlet, i) => {
              const brands = parseBrandsFromApi(outlet);

              return (
                <Accordion
                  key={outlet.outlet_id || i}
                  disableGutters
                  elevation={0}
                  sx={{
                    background: "transparent",
                    borderBottom: "1px solid rgba(0,0,0,0.1)",
                  }}
                >
                  <AccordionSummary expandIcon={<ExpandMore />}>
                    <Box>
                      <Typography fontSize={13} fontWeight={600}>
                        📍 {outlet.outlet}
                      </Typography>

                      <Typography
                        fontSize="0.75rem"
                        color="text.secondary"
                        p={0.5}
                        pb={0}
                      >
                        {outlet.address}
                      </Typography>
                    </Box>
                  </AccordionSummary>

                  <AccordionDetails sx={{ pt: 0 }}>
                    {Object.entries(brands).map(([brand, links]) => (
                      <Box
                        key={brand}
                        display="flex"
                        alignItems="center"
                        justifyContent="space-between"
                        mb={1}
                      >
                        <Typography fontSize="0.9rem">
                          {formatBrand(brand)}
                        </Typography>

                        <Stack direction="row" spacing={1}>
                          {links.grabfood && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                window.open(links.grabfood, "_blank")
                              }
                            >
                              <img
                                src={logoGrabfood}
                                alt="GrabFood"
                                style={{
                                  filter:
                                    "brightness(0) saturate(100%) invert(29%) sepia(39%) saturate(2622%) hue-rotate(349deg) brightness(111%) contrast(99%)",
                                  width: 48,
                                }}
                              />
                            </IconButton>
                          )}

                          {links.gofood && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                window.open(links.gofood, "_blank")
                              }
                            >
                              <img
                                src={logoGofood}
                                alt="GoFood"
                                style={{
                                  filter:
                                    "brightness(0) saturate(100%) invert(29%) sepia(39%) saturate(2622%) hue-rotate(349deg) brightness(111%) contrast(99%)",
                                  width: 48,
                                }}
                              />
                            </IconButton>
                          )}

                          {links.shopeefood && (
                            <IconButton
                              size="small"
                              onClick={() =>
                                window.open(links.shopeefood, "_blank")
                              }
                            >
                              <img
                                src={logoShopeefood}
                                alt="ShopeeFood"
                                style={{
                                  filter:
                                    "brightness(0) saturate(100%) invert(29%) sepia(39%) saturate(2622%) hue-rotate(349deg) brightness(111%) contrast(99%)",
                                  width: 64,
                                }}
                              />
                            </IconButton>
                          )}
                        </Stack>
                      </Box>
                    ))}
                  </AccordionDetails>
                </Accordion>
              );
            })}
          </Box>
          
          {/* List Online */}
          {/* <Grid 
            container 
            spacing={2}                         
            sx={{              
              p: 1,
              pl: 0,              
            }}
          >
            <Grid item xs={4}>             
              <Box sx={{ justifyItems: "center" }}>
                <Typography>Seojun</Typography>                
                <Typography >GrabFood</Typography>
                <Typography>GoFood</Typography>
                <Typography>ShopeeFood</Typography>                
              </Box>
            </Grid>

            <Grid item xs={4}>              
              <Box sx={{ textAlign: "center" }}>
                <Typography>Sasmita</Typography>                
                <Typography>GrabFood</Typography>
                <Typography>GoFood</Typography>
                <Typography>ShopeeFood</Typography>                
              </Box>
            </Grid>

            <Grid item xs={4}>              
              <Box sx={{ textAlign: "center" }}>
                <Typography>Astugo</Typography>                
                <Typography>GrabFood</Typography>
                <Typography>GoFood</Typography>
                <Typography>ShopeeFood</Typography>                
              </Box>
            </Grid>
          </Grid> */}

          {/* List icon */}
          {/* <div className="footer-social-btn-list-mobile">
            <div
              className="footer-icon-element-mobile"
              onClick={() => {
                window.open("https://gofood.link/a/HKJ97Fw");
              }}
            >
              <img src={Gofood_logo} alt="gofood" width="30%" />
            </div>
          </div> */}

          {/* <br />
          <Divider width="90%" height="4px" color="grey" margintop="1em" /> */}

          {/* Location */}
          {/* <Box
            width="100%"
            minHeight="2em"
            padding="1em"
            backgroundColor="ivory"
            display="flex"
            flexDirection="column"
            alignItems="center"
            justifyContent="center"
          >
            <div className="footer-subtitle-mobile">
              Jl. Taman Cibeunying Utara, Bandung Wetan, 40114
            </div>
          </Box> */}

          {/* Copyright */}
          <div className="footer-bottom-text">© 2026 kabitagroup</div>
        </Box>
      )}

      {/* Desktop */}
      {desktop_size && (
        <Box
          width="100%"
          minHeight="2em"
          padding="1em"
          display="flex"
          flexDirection="column"
          alignItems="center"
          backgroundColor="ivory"
        >
          <Box
            width="80vw"
            display="flex"
            flexDirection="row"
            alignItems="flex-start"
            justifyContent="center"
            sx={{ paddingY: "1em" }}
            marginBottom="1em"
          >
            <Box flex="1">
              <div className="footer-title">Seojun Fried Chicken</div>
              <div className="footer-subtitle">Your daily happiness</div>

              <div className="footer-bottom-text">
                © 2026 kabitagroup
              </div>
            </Box>
            <Box flex="1" display="flex" flexDirection="column">
              <div className="footer-title">Navigation</div>
              <a className="footer-link" href="#section-menu">
                Menu
              </a>
              {/* <a className="footer-link" href="#section-location">
                Location
              </a> */}
            </Box>

            <Box flex="1">
              <div className="footer-title">Follow Us</div>
              <div className="footer-social-btn-list">
                <IconButton
                  onClick={() => {
                    window.open(
                      "https://instagram.com/seojunfriedchicken?igshid=MzRlODBiNWFlZA=="
                    );
                  }}
                >
                  <InstagramIcon sx={{ width: "1em", height: "1em" }} />
                </IconButton>
              </div>
            </Box>

            <Box flex="1">
              <div className="footer-title">Location</div>
              <div className="footer-subtitle">
                Jl. Taman Cibeunying Utara, Bandung Wetan, 40114
              </div>
            </Box>
          </Box>
        </Box>
      )}
    </>
  );
};
export default Footer;
